export const ROUTES = {
  applications: {
    fraudFlags: (financingProgramId: string, creditApplicationId: string) : string =>
      `${window.location.origin}/Applications/${financingProgramId}/${creditApplicationId}/fraud-flags`,
  }
}